import TopBanner from '../components/Wishlist/TopBanner'
import ProductWishlist from '../components/Wishlist/ProductWishlist'

const Wishlist = () => {
    return (
        <>
            <TopBanner />
            <ProductWishlist />
        </>
    )
}

export default Wishlist